import React, { useContext, useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { fget, fpatch } from "../../../../API/callsAPI";

//@MUI
import {
  Checkbox,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import useStyles from "./ReviewVersionOverview.styles";

//@Components
import { MovieColabContext } from "../../../../Context/MovieColabContext";
import ReviewPageManageReviewModal from "../../../Reviews/ReviewPageModals/ReviewPageManageReviewModal";
import ReviewPageNoData from "../../../Reviews/ReviewPageNoData/ReviewPageNoData";
import {
  fakeVersions,
  reviewVersionFakeData,
} from "../../../Reviews/ReviewerPageFakeData.js";
import ReviewTools from "../../../Reviews/ReviewsPageTools/ReviewsPageTool.component";
import {
  StatusDirectionAvatar,
  VersionViewerAvatar,
} from "../../../Utilities/AppTour/AppTourCustomAvatars/AppTourCustomAvatars.jsx";
import CustomAppTour from "../../../Utilities/AppTour/CustomAppTour/CustomAppTour";
import CustomPagination from "../../../Utilities/CustomPagination/CustomPagination.component";
import ErrorOrSuccessMessage from "../../../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";
import Loader from "../../../Utilities/Loader/Loader";
import MoveReviewVersionToShotModal from "../../../Utilities/ReviewPageVersionViewer/MoveReviewVersionToShotModal.jsx";
import ReviewPageVersionViewerOverview from "../../../Utilities/ReviewPageVersionViewer/ReviewPageVersionViewerOverview/ReviewPageVersionViewerOverview";
import { checkImage } from "../../../utils";
import ReviewVersionList from "../../ReviewVersionList/ReviewVersionList.component";
import ReviewVersionNewReviewModal from "../../ReviewVersionModals/ReviewVersionNewReviewModal";

function ReviewVersionOverview(props) {
  const classes = useStyles();
  const history = useHistory();
  const lastSelectedIndexRef = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [signedUrl, setSignedUrl] = useState("");
  const [isNewReviewVersionModalOpen, setNewReviewVersionModalOpen] =
    useState(false);
  const [isManageReviewerModalOpen, setManageReviewerModalOpen] =
    useState(false);
  const [isReviewVersionTogglerOn, setIsReviewVersionTogglerOn] =
    useState(false);
  const [isVersionViewerOpen, setVersionViewerOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterStatus, setFilterStatus] = useState("");
  const [updateOnPageChange, setUpdateOnPageChange] = useState(0);
  const [orgUsers, setOrgUsers] = useState([]);
  const [projectReviewer, setProjectReviewer] = useState([]);
  const [reviewVersions, setReviewVersions] = useState([]); //review versions
  const [selectedVersion, setSelectedVersion] = useState(); //selected version for version viewer
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false); //for view modal for corners out button
  const { loggedInUser } = useContext(MovieColabContext);
  const [allUsersName, setAllUsersName] = useState([]);
  const [parentReview, setParentReview] = useState({});
  const [commentId, setCommentId] = useState("");
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const [statusList, setStatusList] = useState([]);
  const [appTourRun, setAppTourRun] = useState(false);
  // bulk update
  const [isMultiSelectEnabled, setIsMultiSelectEnabled] = useState(false);
  const [selectedShots, setSelectedShots] = useState([]);
  const [isBulkMoveModalOpen, setIsBulkMoveModalOpen] = useState(false);

  const decodedURL = decodeURIComponent(
    escape(window.atob(history.location.search.substring(1)))
  );
  const searchParams = new URLSearchParams(decodedURL);

  const handleNewReviewVersionModal = () => {
    setNewReviewVersionModalOpen(!isNewReviewVersionModalOpen);
  };

  const handleManageReviewModal = () => {
    setManageReviewerModalOpen(!isManageReviewerModalOpen);
  };

  const handleReviewVersionToggler = () => {
    setIsReviewVersionTogglerOn(!isReviewVersionTogglerOn);
  };

  const handleViewModal = () => {
    setIsViewModalOpen(!isViewModalOpen);
  };

  useEffect(() => {
    if (selectedVersion && selectedVersion.id) {
      searchParams.set("versionId", `${selectedVersion.id}`);
      const updatedUrl = `${"?" + btoa(unescape(encodeURIComponent(searchParams.toString())))
        }`;
      window.history.replaceState({ path: updatedUrl }, "", updatedUrl);
      setVersionViewerOpen(true);
    }
  }, [selectedVersion]);

  useEffect(() => {
    if (
      reviewVersions.results &&
      reviewVersions.results.length > 0 &&
      searchParams.get("versionId")
    ) {
      const version = reviewVersions.results.filter(
        (eachVersion) => eachVersion.id == searchParams.get("versionId")
      );
      if (version) {
        setSelectedVersion(version[0]);
      }
    }
  }, [reviewVersions]);

  const handleVersionViewer = (version) => {
    if (version) {
      setSelectedVersion(version);
    }
  };

  const handlePageChange = (pageNo) => {
    setCurrentPage(pageNo);
    setUpdateOnPageChange(updateOnPageChange + 1);
  };

  const updateRefreshCounter = () => {
    setRefreshCounter(refreshCounter + 1);
  };

  const getReviewVersions = async () => {
    setIsLoaded(false);
    try {
      const versionRes = await fget({
        url: `review/${props.params.id}/versions/?page=${currentPage}${filterStatus ? `&status=${filterStatus}` : ""
          }`,
      });

      if (versionRes.status === 200) {
        setReviewVersions(versionRes.data);
        setIsLoaded(true);
      }
    } catch (error) {
      setIsLoaded(true);
      console.log(error);
    }
  };

  const fetchOrghUsers = async () => {
    try {
      const usersRes = await fget({
        url: `project/${props.params.projectId}/users/`,
      });
      if (usersRes.status === 200) {
        setOrgUsers(
          usersRes.data.results.map((user) => {
            const data = {
              label: user.first_name + " " + user.last_name,
              value: user.id,
              avatar: user?.avatar,
              email: user.email,
            };
            return data;
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getReviewer = async () => {
    try {
      const usersRes = await fget({
        url: `project/${props.params.projectId}/reviewers`,
      });
      if (usersRes.status === 200) {
        setProjectReviewer(
          usersRes.data.results.map((user) => {
            const data = {
              label: user.first_name + " " + user.last_name,
              value: user.id,
              avatar: user?.avatar,
              email: user.email,
            };
            return data;
          })
        );

        const usersData = usersRes.data.results.map((user) => {
          const data = {
            name: user.first_name + " " + user.last_name,
            id: user.id,
            email: user.email,
            avatar: user.avatar,
            first_name: user.first_name,
            last_name: user.last_name,
          };
          return data;
        });
        setAllUsersName((prev) => [...prev, ...usersData]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUsers = async () => {
    try {
      const usersRes = await fget({
        url: `project/${props.params.projectId}/users/`,
      });
      const usersData = usersRes.data.results.map((user) => {
        const data = {
          name: user.first_name + " " + user.last_name,
          id: user.id,
          email: user.email,
          avatar: user.avatar,
          first_name: user.first_name,
          last_name: user.last_name,
        };
        return data;
      });
      setAllUsersName((prev) => [...prev, ...usersData]);
    } catch (error) {
      console.log(error);
    }
  };

  const updateVersionStatus = async (versionStatus) => {
    let statusObj = {
      url: `review-version/${selectedVersion.id}/`,
      data: { status: versionStatus },
    };
    try {
      const res = await fpatch(statusObj);
      if (res.status === 200 || 201) {
        updateRefreshCounter();
        return Promise.resolve(res);
      }
    } catch (error) {
      return Promise.reject(error);
    }
  };

  const fetchFile = async (id) => {
    const fetchFileRes = await fget({
      url: `reviewversion/${id}/file`,
    });
    setSignedUrl(fetchFileRes.data.signed_url);
  };

  const getParentReview = async () => {
    try {
      const res = await fget({
        url: `project/${props.params.projectId}/reviews/${props.params.id}/`,
      });
      if (res.status === 200) {
        setParentReview(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectOrUnSelectShot = (shot, index, e) => {
    if (e.shiftKey && lastSelectedIndexRef.current !== null) {
      const start = Math.min(lastSelectedIndexRef.current, index);
      const end = Math.max(lastSelectedIndexRef.current, index);
      const reviewVersionsInRange = reviewVersions.results.slice(start + 1, end + 1);
      setSelectedShots((prev) => {
        const existingIds = new Set(prev.map((s) => s.id));
        const toAdd = reviewVersionsInRange.filter((s) => !existingIds.has(s.id));
        return [...prev, ...toAdd];
      });
    } else {
      const isExist = selectedShots?.find((sin) => sin.id === shot.id);
      if (isExist) {
        const others = selectedShots.filter((sin) => sin.id !== shot.id);
        setSelectedShots(others);
      } else {
        setSelectedShots((selectedShots) => [...selectedShots, shot]);
      }
      lastSelectedIndexRef.current = index;
    }
  };

  useEffect(() => {
    getReviewVersions();
  }, [updateOnPageChange, refreshCounter, filterStatus]);

  useEffect(() => {
    getParentReview();
    if (!props.externalReviewer) {
      fetchOrghUsers();
    }
    getReviewer();
    fetchUsers();
    setCommentId(searchParams.get("commentId" || ""));
  }, []);

  useEffect(() => {
    const open = localStorage.getItem("externalVersionAppTour");
    if (open === null) {
      setAppTourRun(true);
    } else {
      setAppTourRun(false);
    }
  }, []);

  useEffect(() => {
    const getStatus = async () => {
      try {
        const res = await fget({
          url: `trackables/status-list/45/?project=${props.params.projectId}`,
        });
        if (res.status === 200 || res.status === 201) {
          setStatusList(res.data.results);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getStatus();
  }, [props.params.projectId]);

  const steps = [
    {
      content: (
        <div>
          We shall now load{" "}
          <strong style={{ color: "#6C65D9" }}>demonstrational content</strong>{" "}
          to help simulate an External Reviewers journey
        </div>
      ),
      placement: "center",
      target: "body",
    },
    {
      target: "#version-file-track",
      content: <StatusDirectionAvatar />,
    },
    {
      placement: "center",
      target: "body",
      content: <VersionViewerAvatar />,
    },
    /* {
      placement: "left",
      target: "#annotation-button",
      content: <VersionViewerAvatar />,
    }, */
  ];

  return (
    <div className={classes.root} id="version">
      <ErrorOrSuccessMessage snackValue={snackValue} />
      <CustomAppTour
        run={appTourRun}
        steps={steps}
        handleFinish={() => {
          localStorage.setItem("externalVersionAppTour", false);
          setAppTourRun(false);
          history.push(`/${props.params.projectId}/review`);
        }}
        handleOthers={(e) => {
          if (e.index === 2) {
            setSelectedVersion(reviewVersionFakeData);
            setVersionViewerOpen(true);
          } else {
            setVersionViewerOpen(false);
          }
        }}
      />
      <ReviewTools
        handleNewReviewModal={handleNewReviewVersionModal}
        handleManageReviewModal={handleManageReviewModal}
        handleReviewToggler={handleReviewVersionToggler}
        isReviewVersion={"yes"}
        isExternalReviewer={props.externalReviewer}
        parentReview={parentReview}
        statusCount={reviewVersions?.version_status_count}
        setFilterStatus={(status) =>
          setFilterStatus(status === filterStatus ? "" : status)
        }
        filterStatus={filterStatus}
        handleToggleMultiSelect={() =>
          setIsMultiSelectEnabled(!isMultiSelectEnabled)
        }
        handleOpenBulkMoveModal={() => setIsBulkMoveModalOpen(true)}
        isMultiSelectEnabled={isMultiSelectEnabled}
        handleClearSelection={() => {
          setSelectedShots([]);
          // setIsBulkMoveModalOpen(false);
          // setIsMultiSelectEnabled(false);
        }}
      />
      {isLoaded ? (
        reviewVersions.count !== 0 ? (
          <>
            <TableContainer className={classes.tableContainer}>
              <Table
                stickyHeader
                className={classes.table}
                aria-label="simple table"
              >
                <TableHead className={classes.tableHeader}>
                  <TableRow className={classes.tableRow}>
                    {isMultiSelectEnabled && (
                      <TableCell
                        align="left"
                        className={classes.headTableCell}
                        style={{
                          width: "40px",
                        }}
                      >
                        <Checkbox
                          checked={
                            selectedShots?.length ===
                            reviewVersions.results?.length
                          }
                          onClick={() =>
                            selectedShots?.length ===
                              reviewVersions.results?.length
                              ? setSelectedShots([])
                              : setSelectedShots(reviewVersions.results)
                          }
                          inputProps={{ "aria-label": "controlled" }}
                          style={{
                            padding: "0",
                            minHeight: "0",
                          }}
                        />
                      </TableCell>
                    )}
                    <TableCell className={classes.headTableCell} align="left">
                      Version Name
                    </TableCell>
                    <TableCell className={classes.headTableCell} align="center">
                      Note
                    </TableCell>
                    <TableCell className={classes.headTableCell} align="center">
                      Added On
                    </TableCell>
                    {!props.externalReviewer && (
                      <TableCell
                        className={classes.headTableCell}
                        align="center"
                      >
                        Added by
                      </TableCell>
                    )}
                    <TableCell className={classes.headTableCell} align="center">
                      Reviewer
                    </TableCell>
                    <TableCell className={classes.headTableCell} align="center">
                      Comments
                    </TableCell>
                    <TableCell className={classes.headTableCell} align="right">
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {appTourRun ? (
                    <ReviewVersionList
                      isReviewVersionTogglerOn={isReviewVersionTogglerOn}
                      isExternalReviewer={props.externalReviewer}
                      handleVersionViewer={handleVersionViewer}
                      review={reviewVersionFakeData}
                      key={reviewVersionFakeData.id}
                      updateRefreshCounter={updateRefreshCounter}
                      setSnackValue={setSnackValue}
                      fetchFile={fetchFile}
                      handleViewModal={handleViewModal}
                      loggedInUser={loggedInUser}
                    />
                  ) : (
                    <>
                      {reviewVersions?.results?.map((review, index) => {
                        return (
                          <ReviewVersionList
                            isReviewVersionTogglerOn={isReviewVersionTogglerOn}
                            isExternalReviewer={props.externalReviewer}
                            handleVersionViewer={handleVersionViewer}
                            review={review}
                            key={review.id}
                            updateRefreshCounter={updateRefreshCounter}
                            setSnackValue={setSnackValue}
                            fetchFile={fetchFile}
                            handleViewModal={handleViewModal}
                            loggedInUser={loggedInUser}
                            isMultiSelectEnabled={isMultiSelectEnabled}
                            selectedReviews={selectedShots}
                            handleSelectOrUnSelectShot={(e) =>
                              handleSelectOrUnSelectShot(review, index, e)
                            }
                          />
                        );
                      })}
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <footer style={{ bottom: "0", height: "100%" }}>
              <div>
                <CustomPagination
                  handlePageChange={handlePageChange}
                  currentPage={currentPage}
                  totalItem={reviewVersions?.count}
                  totalPage={Math.ceil(reviewVersions?.count / 50)}
                  // setIsNewPageLoading={setIsNewPageLoading}
                  trackable="Review Versions"
                  isExternalReviewer={props.externalReviewer}
                />
              </div>
            </footer>
          </>
        ) : (
          <ReviewPageNoData
            filterCompleted={"False"}
            handleNewReviewModal={handleNewReviewVersionModal}
            isReviewVersion={true}
            isExternalReviewer={props.externalReviewer}
          />
        )
      ) : (
        <Loader />
      )}
      <Modal
        open={isBulkMoveModalOpen}
        onClose={() => setIsBulkMoveModalOpen(false)}
        className={classes.reviewPageModals}
      >
        <MoveReviewVersionToShotModal
          projectId={props.params.projectId}
          selectedVersion={selectedShots}
          isBulkMove={true}
          handleClose={() => setIsBulkMoveModalOpen(false)}
        />
      </Modal>
      <div>
        <Modal
          className={classes.reviewPageModals}
          open={isNewReviewVersionModalOpen}
          onClose={handleNewReviewVersionModal}
        >
          <ReviewVersionNewReviewModal
            handleNewReviewVersionModal={handleNewReviewVersionModal}
            setSnackValue={setSnackValue}
            reviewId={props.params.id}
            updateRefreshCounter={updateRefreshCounter}
          />
        </Modal>
      </div>
      <div>
        <Modal
          className={classes.reviewPageModals}
          open={isManageReviewerModalOpen}
          onClose={handleManageReviewModal}
        >
          <ReviewPageManageReviewModal
            handleManageReviewModal={handleManageReviewModal}
            orgUsers={orgUsers}
            setSnackValue={setSnackValue}
            projectId={props.params.projectId}
            projectReviewer={projectReviewer}
            getReviewer={getReviewer}
          />
        </Modal>
      </div>
      <div>
        <Modal
          className={classes.reviewPageModals}
          open={isVersionViewerOpen}
          onClose={() => {
            setSelectedVersion("");
            searchParams.set("versionId", "");
            const updatedUrl = `${"?" + btoa(unescape(encodeURIComponent(searchParams.toString())))
              }`;
            window.history.replaceState({ path: updatedUrl }, "", updatedUrl);
            setVersionViewerOpen(false);
          }}
        >
          <ReviewPageVersionViewerOverview
            onClose={() => {
              setSelectedVersion("");
              searchParams.set("versionId", "");
              const updatedUrl = `${"?" +
                btoa(unescape(encodeURIComponent(searchParams.toString())))
                }`;
              window.history.replaceState({ path: updatedUrl }, "", updatedUrl);
              setVersionViewerOpen(false);
            }}
            selectedVersion={selectedVersion}
            setSelectedVersion={setSelectedVersion}
            versionList={appTourRun ? fakeVersions : reviewVersions.results}
            updateVersionStatus={updateVersionStatus}
            projectId={props.params.projectId}
            isExternalReviewer={props.externalReviewer}
            loggedInUser={loggedInUser}
            allUsersName={allUsersName}
            parentReview={parentReview}
            isAppTourRunning={appTourRun}
            commentId={commentId}
            statusList={statusList}
            updateRefreshCounter={updateRefreshCounter}
          />
        </Modal>
      </div>
      <div>
        <Modal
          className={classes.reviewPageModals}
          open={isViewModalOpen}
          onClose={handleViewModal}
        >
          {signedUrl ? (
            checkImage(signedUrl) ? (
              <img
                src={signedUrl}
                className="card-img-top"
                style={{ width: "500px", height: "auto" }}
                alt="asset"
              />
            ) : (
              <video
                src={signedUrl}
                controls
                autoPlay
                style={{ width: "auto", height: "500px" }}
              />
            )
          ) : (
            <span>No file found</span>
          )}
        </Modal>
      </div>
    </div>
  );
}

export default ReviewVersionOverview;
